import {getBlob} from "../../../admin/script/util/http.js";
import {downloadFileBlob} from "../../../admin/script/util/browser.js";

/**
 *
 * @param {String} url
 * @param {HTMLElement} buttonElement
 * @return {Promise<FileBlob>}
 */
export const downloadUrlFile = async (url, buttonElement) => {
    if (buttonElement) {
        POLKURIER.setButtonBusyState(buttonElement, {
            size: buttonElement.classList.contains('fs-nano') ? 'nano' : 'sm',
        });
    }
    try {
        const file = await getBlob(url);
        downloadFileBlob(file);
        return file;
    } catch (e) {
        if (e.status !== 200 && typeof e.text === 'function') {
            e.text().then(function (message) {
                POLKURIER.showErrorPopup(message);
            });
        } else {
            POLKURIER.showErrorPopup(e);
        }
    } finally {
        if (buttonElement) {
            POLKURIER.unsetButtonBusyState(buttonElement);
        }
    }
}
